<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <FormulatingFoundationsCheckout :combos="combos" :variant="variant" />
  </b-container>
</template>
<style>
</style>

<script>
import FormulatingFoundationsCheckout from "@/components/checkout/formulatingfoundations/FormulatingFoundationsCheckout.vue";

export default {
  title: "Formulating Foundations Checkout",
  name: "FormulatingFoundations",
  props: ["combos"],
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  computed: {
    variant: function () {
      return 'C';
    },
  },
  components: {
    FormulatingFoundationsCheckout,
  },
};
</script>
